import {PricingConfig} from '@flexinet/pricing-components';
import {stage} from './stage.ts';

const platformApi: PricingConfig['platformApi'] = {
    prod: {
        endpoint: 'https://jerup2o5nzej3hnn2sdv3ejtca.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: '6c6f8e3b-f83d-4520-9b5b-5532d42e25af',
    },
    test: {
        endpoint: 'https://thz4u5ksajh6blvulnhiiddudi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
    },
    dev: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: 'b7c64440-55d7-47d6-81b4-77468bf9b7ca',
    },
    ide: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: 'b7c64440-55d7-47d6-81b4-77468bf9b7ca',
    },
};

export const publicPricingConfig: PricingConfig = {
    stage,
    authMode: 'iam',
    pricingPageTitle: 'Flexi Domains Service Plans',
    pricingPageSmallScript: 'Please note that these prices are subject to change. Actual prices may vary',
    platformApi,
};

export const authenticatedPricingConfig: PricingConfig = {
    stage,
    authMode: 'userPool',
    pricingPageTitle: 'Flexi Domains Service Plans',
    pricingPageSmallScript: 'Please note that these prices are subject to change. Actual prices may vary',
    platformApi,
};
